import firebase from "firebase/app"
import "firebase/auth";
import "firebase/database";

const getFirebaseLikes = async function (user) {
    const uid = user.uid;
    const userRef = firebase.database().ref(`stylight/likes/${uid}`);

    let likes = new Promise(function(resolve){
        userRef.once('value')
            .then(function (snapshot) {
                let likes = [];
                snapshot.forEach(function (childSnapshot) {
                    likes.push(childSnapshot.key);
                });
                resolve(likes);
            });
    });

    return await likes;
};

export const LikeUtil = {
    getLikes: async function() {
        const currentUser = firebase.auth().currentUser;
        if (currentUser) {
            return await getFirebaseLikes(currentUser);
        }

        return [];
    }
}